<template>
  <component :is="embedded ? 'div' : 'v-main'">
    <component :is="embedded ? 'div' : 'v-container'" v-bind="embedded ? {} : { fluid: true }">
      <component :is="embedded ? 'div' : 'v-card'" v-bind="embedded ? {} : { elevation: 6, rounded: 'xxl' }" :class="embedded ? '' : 'app-card'">
        <v-card-title class="mt-4" v-if="!embedded">
          <v-btn class="mx-2" fab x-small color="primary" @click="$router.back()">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Edit Category
        </v-card-title>
        <component :is="embedded ? 'div' : 'v-card-text'">
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.name"
                @input="form.name = form.name.toUpperCase()"
              >
                <template v-slot:label>Category Name <span style="color:#f44336;font-weight:bold;">*</span></template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn text class="mr-2" @click="embedded ? $emit('close') : $router.back()">Cancel</v-btn>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading || !form.name"
            @click="save"
          >
            Update Category
          </v-btn>
        </component>
      </component>
    </component>
  </component>
</template>

<script>
import axios from "axios";

export default {
  name: "CategoryEditPage",
  props: {
    embedded: { type: Boolean, default: false },
    categoryId: { type: String, default: null },
  },
  data() {
    return {
      form: {
        name: "",
      },
      isLoading: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters["errors/getErrors"] || {};
    },
  },
  mounted() {
    this.$store.dispatch("errors/setErrors", {});
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.categoryId || this.$route.params.categoryId;
      axios
        .get(`/categories/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          console.log(this.form);
          this.old_json = response.data.data;
          // this.getUplineUsers();
        })
        .catch((error) => {
          // redirect to Home Page
          // window.location.href = "/auth/login";
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },

    // async fetchCategory() {
    //   this.isLoading = true;
    //   try {
    //     const response = await axios.get(`/categories/${this.categoryId}`);
    //     this.form = response.data.data || "";
    //   } catch (error) {
    //     console.error("Error fetching category:", error);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    async save() {
      this.isLoading = true;
      this.$store.dispatch("errors/setErrors", {});
      try {
        const targetId = this.categoryId || this.$route.params.categoryId;
        await axios.patch(`/categories/${targetId}`, this.form);
        this.isLoading = false;
        if (this.embedded) {
          this.$emit("saved");
          this.$emit("close");
        } else {
          this.$router.push("/categories");
        }
      } catch (error) {
        console.error("Error updating category:", error);
        this.isLoading = false;
        if (error.response && error.response.data && error.response.data.errors) {
          this.$store.dispatch("errors/setErrors", error.response.data.errors);
        }
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  padding: 20px;
}
</style>
